import './PopUp.css'
import { useEffect, useState , memo } from "react";

const PopUp = memo(({children , isShow , popUpHandler , navigateToResult}) => {

 const isShowPopUpHandler = (status) => {
    popUpHandler(status)
 }

  return (
    <>
      <div className={`overlay ${!isShow && 'overlay_disabled'}`}></div>

      <div className={`popup ${!isShow && 'popup_disabled'}`}>
        <div className="popup__content">
            {children}
        </div>

        <div className="buttons_box">
          <button onClick={() => {isShowPopUpHandler(false)}} className="buttons_box__button buttons_box__button_cancel button__right_border">
            خیر
          </button>
          <button onClick={() => {navigateToResult()}} className="buttons_box__button buttons_box__button_ok">
            بله
          </button>
        </div>
      </div>
    </>
  );
})

export default PopUp;
